import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import icon from 'flarum/common/helpers/icon';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';

export default class ActivityLeaderItem_Discussions extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { user, position } = this.attrs;

		return (
			<div className='PostActivityLeaderItem'>
				<Link href={app.route.user(user)}>
					<span className='ActivityLeaderItem-position'>
						{position.toString().padStart(2, '0')}
					</span>
					{avatar(user)}
					<div className='ActivityLeaderItem-username'>
						{username(user)}

						{user.lastSeenAt() && user.isOnline() && (
							<div className='UserCard-lastSeen online'>
								{icon('fas fa-circle')}{' '}
								{app.translator.trans('core.forum.user.online_text')}
							</div>
						)}
					</div>
					<span className='ActivityLeaderItem-count'>
						{icon(this.icon)}
						{this.value}
					</span>
				</Link>
			</div>
		);
	}

	get value() {
		const { user } = this.attrs;
		//return user.recentPostsCount();
        return user.discussionCount();
	}

	get icon() {
		return 'far fa-comment';
	}
}
